import Vue from 'vue'
import qs from 'qs'

export default {
  getAll (getActiveOnly = false, withRelationships = []) {
    withRelationships = Array.join(withRelationships)
    return Vue.http.get('/rental/locations', {
      params: {
        getActiveOnly: getActiveOnly,
        withRelationships: withRelationships
      }
    })
  },

  activate (vendingMachineId) {
    return Vue.http.post(`/rental/locations/activate/${vendingMachineId}`)
  },

  get (id) {
    return Vue.http.get(`/rental/locations/${id}`)
  },

  list (from, to, config = {}) {
    return Vue.http.get('/rental/location_sales', {
      params: {
        from,
        to
      },
      ...config
    })
  },

  transactions (id, query) {
    return Vue.http.get(`/rental/locations/${id}/transactions`, {
      params: query,
      paramsSerializer: qs.stringify
    })
  },

  getProducts (id, withCombos = false, withPromotion = false) {
    return Vue.http.get(`/rental/locations/${id}/products`, {
      params: {
        with_combos: withCombos,
        with_promotion: withPromotion
      }
    })
  },
}



// WEBPACK FOOTER //
// ./src/services/rental/location.js